import script from "./OnlineMessageKnowledgeBaseArticleContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnlineMessageKnowledgeBaseArticleContent.vue?vue&type=script&lang=ts&setup=true"

import "./OnlineMessageKnowledgeBaseArticleContent.vue?vue&type=style&index=0&id=d0a3a078&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a3a078"]])

export default __exports__